import React from 'react';

interface RatingSelectorProps {
  value: number;
  onChange: (num: number) => void;
  activeColor?: 'indigo' | 'emerald';
  lowLabel?: string;
  highLabel?: string;
}

export const RatingSelector: React.FC<RatingSelectorProps> = ({
  value,
  onChange,
  activeColor = 'indigo',
  lowLabel,
  highLabel,
}) => {
  const colorClass = activeColor === 'emerald'
    ? 'bg-emerald-600 text-white'
    : 'bg-indigo-600 text-white';

  return (
    <div>
      <div className="flex justify-between gap-1 mb-1">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
          <button
            key={num}
            type="button"
            onClick={() => onChange(num)}
            className={`w-8 h-8 rounded-full text-sm font-bold transition-all ${
              value === num ? `${colorClass} scale-110 shadow-md` : 'bg-slate-100 text-slate-400 hover:bg-slate-200'
            }`}
          >
            {num}
          </button>
        ))}
      </div>
      {(lowLabel || highLabel) && (
        <div className="flex justify-between text-[10px] text-slate-400 px-1 uppercase font-bold tracking-wider">
          <span>{lowLabel}</span>
          <span>{highLabel}</span>
        </div>
      )}
    </div>
  );
};
